import { render } from "./FabButtons.vue?vue&type=template&id=2a9bf4e9&scoped=true"
import script from "./FabButtons.vue?vue&type=script&lang=js"
export * from "./FabButtons.vue?vue&type=script&lang=js"

import "./FabButtons.vue?vue&type=style&index=0&id=2a9bf4e9&lang=scss&scoped=true"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9bf4e9"]])

export default __exports__